export const TYPE_ACCESS_PENDING = 0;
export const TYPE_ACCESS_APPROVED = 1;
export const TYPE_ACCESS_DECLINED = 2;

export const TYPE_ITEM_ACCESS = "photo"
export const TYPE_CHAT_ACCESS = "chat"